import React from 'react';
import { Subtitle, Title, TitleWrapper } from './MainTitle.style';

interface MainTitleProps {
  title: React.ReactNode;
  subtitle: React.ReactNode;
}

function MainTitle({ title, subtitle }: MainTitleProps) {
  return (
    <TitleWrapper data-test={'main-title'}>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </TitleWrapper>
  );
}

export default MainTitle;
